module.exports = __webpack_public_path__ + "static/media/search.be3a7fd0.svg";